var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import GenericTable from "@frameworks/shared-library/components/GenericTable";
import di from "@frameworks/salesjourney/components/Features/ClientDetails/di/serviceLocator";
import SelectDropdown from "@frameworks/web/components/generic/selectdropdown";
import { getDateInFormat } from "@domains/utils/reportDates";
import { base64toExcel } from "@frameworks/salesjourney/utils/genericMethods";
import { useSelector } from "react-redux";
import { addDashIfNullOrUndefined } from "@domains/utils/numberMethods";
var RelationColumn = [
    {
        columnName: "Date",
        key: "Date",
        tdCustomFunction: function (key) {
            return addDashIfNullOrUndefined(key);
        },
    },
    {
        columnName: "Book Type",
        key: "BookType",
        tdCustomFunction: function (key) {
            return addDashIfNullOrUndefined(key);
        },
    },
    {
        columnName: "Book Code",
        key: "BookCode",
        tdCustomFunction: function (key) {
            return addDashIfNullOrUndefined(key);
        },
    },
    {
        columnName: "Voucher Type",
        key: "VoucherType",
        tdCustomFunction: function (key) {
            return addDashIfNullOrUndefined(key);
        },
    },
    {
        columnName: "Narration",
        key: "Narration",
        tdCustomFunction: function (key) {
            return addDashIfNullOrUndefined(key);
        },
    },
    {
        columnName: "Cheque No",
        key: "ChequeNo",
        tdCustomFunction: function (key) {
            return addDashIfNullOrUndefined(key);
        },
    },
    {
        columnName: "Receipt in Rs",
        key: "ReceiptsInRs",
        tdCustomFunction: function (key) {
            return addDashIfNullOrUndefined(key);
        },
    },
    {
        columnName: "Payment in Rs",
        key: "PaymentsInRs",
        tdCustomFunction: function (key) {
            return addDashIfNullOrUndefined(key);
        },
    },
    {
        columnName: "Cumulative Balance",
        key: "CummulativeBalance",
        tdCustomFunction: function (key) {
            return addDashIfNullOrUndefined(key);
        },
    },
];
var DpLedgerPage = function (props) {
    var _a = __read(useState(new Date()), 2), startDate = _a[0], setStartDate = _a[1];
    var _b = __read(useState([]), 2), yearlist = _b[0], setYearList = _b[1];
    var _c = __read(useState(""), 2), selectYear = _c[0], setSelectedYear = _c[1];
    var _calendar = useRef(null);
    var _d = __read(useState(), 2), relationRows = _d[0], setRelationRows = _d[1];
    var showDatePicker = function (e) {
        if (_calendar.current) {
            _calendar.current.setOpen(true);
        }
    };
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var DPLedger = function () { return __awaiter(void 0, void 0, void 0, function () {
        var resp, dates;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!props.selectedRecord) return [3 /*break*/, 2];
                    return [4 /*yield*/, di.clients.getClientDpLedgerGetCatogeryDetailsData({
                            DpId: (_a = props === null || props === void 0 ? void 0 : props.selectedRecord) === null || _a === void 0 ? void 0 : _a.dpId,
                        })];
                case 1:
                    resp = _b.sent();
                    dates = resp.map(function (item) {
                        return { display: item.FYear, value: item.FYearValue };
                    });
                    setYearList(dates);
                    _b.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var DPLedgerDetails = function (downloadFlag) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            if (yearlist.length > 0 && startDate)
                di.clients
                    .getClientDpLedgerDetailsData({
                    DpId: "".concat((_a = props === null || props === void 0 ? void 0 : props.selectedRecord) === null || _a === void 0 ? void 0 : _a.dpId).concat((_b = props === null || props === void 0 ? void 0 : props.selectedRecord) === null || _b === void 0 ? void 0 : _b.accountNo),
                    CategoryID: selectYear,
                    ForDate: getDateInFormat(startDate, "YYYY-MM-DD"),
                    downloadFlag: downloadFlag,
                })
                    .then(function (val) {
                    if (!downloadFlag)
                        setRelationRows(val === null || val === void 0 ? void 0 : val.showdata);
                    else if (val === null || val === void 0 ? void 0 : val.FileBase64String)
                        base64toExcel(val === null || val === void 0 ? void 0 : val.FileBase64String, "DP_LEDGER_" + getDateInFormat(new Date(), "DD_MM_YYYY") + ".xlsx");
                });
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        DPLedger();
    }, [props.selectedRecord]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "px-0 mx-0 dpledger-block" },
            React.createElement(Row, { className: "px-0 mx-0" },
                React.createElement(Col, { className: "px-0 HeadRow" },
                    React.createElement("span", { className: "EncodeSansN_20_400 txt" },
                        React.createElement("i", { className: "edel-icon-arrow-left", onClick: function () {
                                props.setledgershow(false);
                            } }),
                        "DP Ledger -",
                        React.createElement("span", { className: "EncodeSans_20_700" }, selectedAcount === null || selectedAcount === void 0 ? void 0 :
                            selectedAcount.userName,
                            ", Accode:", selectedAcount === null || selectedAcount === void 0 ? void 0 :
                            selectedAcount.accountCode)))),
            React.createElement(Row, { className: "buttons-block mx-0" },
                React.createElement(Col, { className: "px-0 leadpage-selectdropdown", lg: 3 },
                    React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey" }, "Category"),
                    React.createElement(SelectDropdown, { placeholder: "Select Meeting Type", id: "financial_dropdown", name: "financial_dropdown", selected: true, dropdownOptions: yearlist, required: true, downarrow: "edel-icon-arrow-down", placeholderClassName: "", value: selectYear, onChangeEvent: function (e) { return setSelectedYear(e.target.value); } })),
                React.createElement(Col, { className: "px-0 DateCol", lg: 3 },
                    React.createElement("label", { className: "DMSanN_16_400 txt_primaryGrey" }, "Date"),
                    React.createElement("div", { className: "col leadpage-selectdropdown leadpage-calendar pdl-0" },
                        React.createElement("div", { className: "inputFieldCalendarIcon input-group yearDropdown singleDatePicker holdingReportsDate leadpage-calendar-input" },
                            React.createElement(DatePicker, { ref: _calendar, selected: startDate, onChange: function (date) { return setStartDate(date); }, showYearDropdown: true, showMonthDropdown: true, dateFormat: "d-MMM-yy", placeholderText: "dd-mm-yy" }),
                            React.createElement("span", { className: "input-group-text" },
                                React.createElement("i", { className: "edel-icon-calendar-report", onClick: showDatePicker }))))),
                React.createElement(Col, { className: "px-0 buttoncol", lg: 2 },
                    React.createElement(EdButton, { btnTyp: "midnight-blue", value: "Show", onClick: function () { return DPLedgerDetails(false); }, disabled: yearlist && yearlist.length > 0 && startDate && selectYear
                            ? false
                            : true })),
                React.createElement(Col, { className: "px-0 downloadbtnCol", lg: 3 },
                    React.createElement("label", { className: "displayFlex download-icon-block EncodeSans_14_500 txt-secondarynavy ".concat(yearlist && yearlist.length > 0 && startDate && selectYear
                            ? null
                            : "disabled"), onClick: function () { return DPLedgerDetails(true); } },
                        React.createElement("span", null,
                            React.createElement("i", { className: "edel-icon-download" })),
                        React.createElement("p", { className: "mgl-6" }, "Download the Statement"))),
                React.createElement(Col, { lg: 1 })),
            React.createElement(Row, { className: "mx-0 ledger-table-block" },
                React.createElement(GenericTable, { columns: RelationColumn, data: relationRows, parentClassName: "common-modal-table" })))));
};
export default DpLedgerPage;
